/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-12
 * @brief EHP 이메일 상담 개발
 *
 ********************************************************************/
import React, { useState } from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../recoil/menuState';
// utils
import * as CONST from "../../utils/Const";
//
import InquiryView from "./Inquiry/InquiryView";
import EhpServiceCenter from "../common/link/EhpServiceCenter";
import EhpChatbot from "../common/link/EhpChatbot";
/**
 * @brief EHP 이메일 상담 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
function IntroductionMain(props) {
    //recoil
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    const setPopWin = props.setPopWin;
    const menuItem = props.menuItem;
    const [meun, setMeun] = useState(menuItem);
    const [workMode, setWorkMode] = useState("READ");
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container layout-w1 service-page", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box ${(isLoadingBox) ? "loading__box" : ""}` }, (curTabMenu.tabUrl == CONST.URL_INTRODUCTIONINQUIRT) &&
                    React.createElement(InquiryView, { setPopWin: setPopWin })))),
        (curTabMenu.tabUrl == CONST.URL_INTRODUCTIONINQUIRT) &&
            React.createElement(EhpServiceCenter, null),
        (curTabMenu.tabUrl == CONST.URL_INTRODUCTIONINQUIRT) &&
            React.createElement(EhpChatbot, null)));
}
export default IntroductionMain;
